export const QuestionTypes = {
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE",
  SHORT_ANSWER: "SHORT_ANSWER",
} as const;

export type QuestionType = keyof typeof QuestionTypes;
